import { useState } from 'react';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';
// Keep in sync with /src/scss/_vars.scss and breakpoint definition in koopa-fragment!
const breakpoints = {
    '3xs': '0px',
    '2xs': '374px',
    xs: '576px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
    xl: '1680px',
};
const getBreakpointMediaQuery = (name) => {
    const minWidth = breakpoints[name];
    return matchMedia(`(min-width: ${minWidth})`);
};
export const useBreakpoint = (name) => {
    const [doesMatch, setDoesMatch] = useState(false);
    useIsomorphicLayoutEffect(() => {
        const mediaQuery = getBreakpointMediaQuery(name);
        const updateMatchingState = (mediaQueryListEvent) => {
            setDoesMatch(mediaQueryListEvent.matches);
        };
        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', updateMatchingState);
        }
        else {
            mediaQuery.addListener(updateMatchingState); // Fallback for older browsers
        }
        setDoesMatch(mediaQuery.matches);
        return function cleanup() {
            if (mediaQuery.removeEventListener) {
                mediaQuery.removeEventListener('change', updateMatchingState);
            }
            else {
                mediaQuery.removeListener(updateMatchingState); // Fallback for older browsers
            }
        };
    }, [name, setDoesMatch]);
    return doesMatch;
};
